export default __webpack_public_path__ + "static/triangle.url-815318fc116d176b6d8f8fa19aca14c3.svg";